import React, { useEffect, useState } from 'react';
import './SINFields.css';
import { axiosInstance } from '../../services/axiosConfig';
interface Activity { id: number; codigo: string; descripcion: string; activa: boolean; }
interface Props { value: number | null; onChange: (value: number | null) => void; className?: string; }
export default function ActividadEconomicaSINField({ value, onChange, className = 'apm-select' }: Props) {
    const [activities, setActivities] = useState<Activity[]>([]);
    const [error, setError] = useState(false);
    useEffect(() => {
        let active = true;
        (async () => {
            const result: Activity[] = [];
            for (let page = 1; ; page++) {
                const { data } = await axiosInstance.get('facturacion/actividades-economicas/', { params: { page } });
                result.push(...(Array.isArray(data) ? data : data.results));
                if (Array.isArray(data) || !data.next) break;
            }
            if (active) { setActivities(result.filter(a => a.activa || a.id === value)); setError(false); }
        })().catch(() => { if (active) setError(true); });
        return () => { active = false; };
    }, [value]);
    return <div className="sin-field">
        <label className="sin-field-label">Actividad económica SIN *
            <select aria-label="Actividad económica SIN" className={className} value={value ?? ''} required onChange={e => onChange(e.target.value ? Number(e.target.value) : null)}>
                <option value="">Seleccionar actividad económica</option>
                {activities.map(a => <option key={a.id} value={a.id}>{a.codigo} — {a.descripcion}</option>)}
            </select>
        </label>
        {error && <p role="alert" className="sin-field-error">No se pudieron cargar las actividades económicas SIN.</p>}
    </div>;
}
